import { useTranslation } from 'react-i18next';
import {
  API_DELETE,
  API_PATCH,
  API_POST,
  DBRequest,
  useConfig,
} from '../../../../api/api';
import ExoForm from '../../ExoForm';
import { useState } from 'react';
import * as Yup from 'yup';

export const NewCalCategory = ({ onChange, onClose, startData }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Icon'),
      key: 'icon',
      type: 'icon',
    },
    {
      label: t('Color'),
      key: 'color',
      type: 'color',
    },

    {
      label: t('Name'),
      key: 'label',
      type: 'text',
    },
  ];

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);

    DBRequest({
      config,
      path: isUpdate
        ? `calendar-event-categories/${data.id}`
        : `calendar-event-categories`,
      method: isUpdate ? API_PATCH(data) : API_POST(data),
      onResponse: (res) => {
        onChange(res);
        onClose();
      },
      onLoading: setIsLoading,
    });
  }

  const validationSchema = Yup.object().shape({
    icon: Yup.string().required('Salutation is required'),
    color: Yup.string().required('First Name is required'),
    label: Yup.string().required('Last Name is required'),
  });

  return (
    <ExoForm
      isLoading={isLoading}
      fields={fields}
      onSubmit={handleSubmit}
      noDifferences
      onCancel={onClose}
      startDataCollection={startData}
      header={startData?.id ? t('Update Category') : t('New Category')}
      validationSchema={validationSchema}
    />
  );
};
